import {grpc} from 'grpc-web-client';

export interface GrpcMetadataInterceptor {
  onBeforeSend(metadata: grpc.Metadata): void;
  onReceive(metadata: grpc.Metadata): void;
}

declare global {
  interface Window {
    addGrpcMetadataInterceptor(interceptor: GrpcMetadataInterceptor);
  }
}

let grpcMetadataInterceptors = [];

window.addGrpcMetadataInterceptor = (interceptor: GrpcMetadataInterceptor) => {
  grpcMetadataInterceptors.push(interceptor);
};

const originalInvoke = grpc.invoke;

(<any>grpc).invoke = function(methodDescriptor, props) {
  let metadata = props.metadata || new grpc.Metadata();

  for(let interceptor of grpcMetadataInterceptors) {
    interceptor.onBeforeSend(metadata);
  }

  props.metadata = metadata;

  let originalOnHeaders = props.onHeaders;

  props.onHeaders = (headers) => {
    for(let interceptor of grpcMetadataInterceptors) {
      interceptor.onReceive(headers);
    }

    if(typeof originalOnHeaders === 'function') {
      return originalOnHeaders(headers);
    }
  };

  return originalInvoke.call(grpc, methodDescriptor, props);
};



// WEBPACK FOOTER //
// ./src/grpc-web-client-patch.ts